(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/product-page-onboarding/assets/javascripts/fullscreen-mount.js') >= 0) return;  svs.modules.push('/templates/product-page-onboarding/assets/javascripts/fullscreen-mount.js');
"use strict";

var _svs$onboarding;

const onboardingDomain = svs.components.onboarding.core.utils.onboardingDomain;
const createFullscreenEventHandler = svs.components.onboarding.core.events.eventHandlers.createFullscreenEventHandler;
const FullscreenEventType = svs.components.onboarding.core.events.constants.FullscreenEventType;
const TemplateSelectors = svs.templates.productPageOnboarding.constants.TemplateSelectors;
const _svs$templates$produc = svs.templates.productPageOnboarding.sessionStorage,
  setItem = _svs$templates$produc.setItem,
  getItem = _svs$templates$produc.getItem;


const mainContentEl = document.querySelector('.main-content');
const onboardingFullscreenEl = document.querySelector(TemplateSelectors.TemplateFullscreen);
const bodyContentEl = document.body;
const _ref = ((_svs$onboarding = svs.onboarding) === null || _svs$onboarding === void 0 || (_svs$onboarding = _svs$onboarding.fullscreen) === null || _svs$onboarding === void 0 ? void 0 : _svs$onboarding.data) || {},
  key = _ref.key,
  count = _ref.count,
  displaycount = _ref.displaycount;
if (mainContentEl && onboardingFullscreenEl && key) {
  const _ref2 = getItem(key) || {
      hasTriggered: false
    },
    hasTriggered = _ref2.hasTriggered;
  if (!hasTriggered) {
    const _createFullscreenEven = createFullscreenEventHandler(),
      addFullscreenEventListener = _createFullscreenEven.addEventListener,
      dispatchFullscreenEvent = _createFullscreenEven.dispatchEvent;
    const _onboardingDomain = onboardingDomain(svs.core.data.module, svs.core.data.baseUrl),
      setCount = _onboardingDomain.setCount;
    const updateCount = () => {
      if (displaycount > 0 && count < displaycount) {
        setCount(key, count + 1);
      }
    };
    const showOnboardingFullscreen = () => {
      bodyContentEl.classList.add('onboarding-fullscreen--show', 'body-content--hide');
    };
    const hideOnboardingFullscreen = () => {
      bodyContentEl.classList.remove('onboarding-fullscreen--show', 'body-content--hide');
    };
    const cleanupFullscreen = () => {
      hideOnboardingFullscreen();
      if (onboardingFullscreenEl && onboardingFullscreenEl.parentElement) {
        onboardingFullscreenEl.parentElement.removeChild(onboardingFullscreenEl);
      }
    };
    const onCloseFullscreen = () => {
      dispatchFullscreenEvent(new svs.components.onboarding.core.events.HideFullscreenEvent());
      cleanupFullscreen();
    };
    addFullscreenEventListener(FullscreenEventType.Show, e => {
      const FullscreenComponent = e.detail.component;
      ReactDOM.render(React.createElement(FullscreenComponent, {
        onCloseFullscreen: onCloseFullscreen
      }), onboardingFullscreenEl);
      updateCount();
      setItem(key, {
        hasTriggered: true
      });
      showOnboardingFullscreen();
    });
    addFullscreenEventListener(FullscreenEventType.Hide, () => {
      cleanupFullscreen();
    });
  }
}

 })(window);